/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createFileDownloadResponseFromDiscriminatorValue, createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, type FileDownloadResponse, type HttpValidationProblemDetails, type IError } from '../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /files/{file-id}/revisions/{revisionId}/download
 */
export interface DownloadRequestBuilder extends BaseRequestBuilder<DownloadRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<FileDownloadResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<FileDownloadResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const DownloadRequestBuilderUriTemplate = "{+baseurl}/files/{file%2Did}/revisions/{revisionId}/download";
/**
 * Metadata for all the requests in the request builder.
 */
export const DownloadRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: DownloadRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createFileDownloadResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
